import React from 'react';
import { Modal, Table } from 'antd';
import { observer, inject } from 'mobx-react';
import { Link } from 'react-router-dom';

@inject('deviceGroupStore')
@observer
class GroupModal extends React.Component {
  render() {
    const {
      modalStatus,
      deviceGroupListArr,
      hideModal
    } = this.props.deviceGroupStore;
    const columns = [
      {
        title: '设备编号',
        dataIndex: 'device_id',
        key: 'tag_name',
        width: 200,
        render: text => (
          <Link
            style={{ color: '#49aff7' }}
            to={`/device/info/${text}`}
            onClick={() => (this.props.deviceGroupStore.modalStatus = false)}
          >
            {text}
          </Link>
        )
      },
      {
        title: '固件版本',
        dataIndex: 'firmware_version',
        key: 'firmware_version',
        width: 200
      },
      { title: '地位地址', dataIndex: 'address', key: 'address', width: 400 }
    ];
    return (
      <div>
        <Modal
          title="分组名称"
          visible={modalStatus}
          onCancel={hideModal}
          closable={false}
          footer={null}
          width={'50%'}
        >
          <Table columns={columns} dataSource={[...deviceGroupListArr]} />
        </Modal>
      </div>
    );
  }
}
export default GroupModal;



// WEBPACK FOOTER //
// ./src/components/DeviceGroup/GroupModal.js